// extracted by mini-css-extract-plugin
module.exports = {"certified-assets":"CertifiedOnceAssets_certified-assets__1Hxs8"};